import React from 'react'
import {Collapse} from "@material-ui/core";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import getObjectValue from "libs/getObjectValue";


function ObjectiveEvidenceData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    return (<>

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("objectiveEvidenceInfo")}
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("plansEvidence")}
        />

        <Collapse in={gVal("plansEvidence") === true}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("plansEvidenceInfo")}
                multiline
                required
            />
        </Collapse>

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("otherDocumentsList")}
            multiline
        />

    </>)
}

ObjectiveEvidenceData.propTypes = {};

export default ObjectiveEvidenceData;
